import T4A from '../../../components/T4A';

function ModifyInfoT4A() {
    return (
        <div>
            <T4A />
        </div>
    )
}
export default ModifyInfoT4A;